import Marquee from "react-fast-marquee";

const ITEMS = [
  "Premium Quality",
  "Authentic Indian Tradition",
  "Carefully Packed",
  "Made in India",
  "A2 Gir Cow Ghee",
  "Pure by Tradition",
];

export default function TrustMarquee() {
  return (
    <div
      data-testid="trust-marquee"
      className="border-y border-forest/10 bg-cream py-6"
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-14 flex items-center gap-14">
            <span className="font-heading text-2xl italic text-forest/80 md:text-3xl">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-gold" aria-hidden />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
